import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';

import { Providers } from './lib/providers';

// // Validate environment variables
// try {
//   validateEnv();
// } catch (error) {
//   console.error('Environment validation failed:', error);
// }

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Providers>
      <App />
    </Providers>
  </React.StrictMode>
);
